// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/model_registry.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import { file_chalk_flags_v1_flags } from "../../flags/v1/flags_pb";
import type { SourceFileReference } from "../../graph/v1/source_file_reference_pb";
import { file_chalk_graph_v1_source_file_reference } from "../../graph/v1/source_file_reference_pb";
import type { ModelArtifactSpec } from "../../models/v1/model_artifact_pb";
import { file_chalk_models_v1_model_artifact } from "../../models/v1/model_artifact_pb";
import type { FieldMask, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/model_registry.proto.
 */
export const file_chalk_server_v1_model_registry: GenFile = /*@__PURE__*/
  fileDesc("CiRjaGFsay9zZXJ2ZXIvdjEvbW9kZWxfcmVnaXN0cnkucHJvdG8SD2NoYWxrLnNlcnZlci52MSKABAoNTW9kZWxBcnRpZmFjdBIKCgJpZBgBIAEoCRIMCgRwYXRoGAIgASgJEjAKBHNwZWMYAyABKAsyIi5jaGFsay5tb2RlbHMudjEuTW9kZWxBcnRpZmFjdFNwZWMSPgoIbWV0YWRhdGEYBiADKAsyLC5jaGFsay5zZXJ2ZXIudjEuTW9kZWxBcnRpZmFjdC5NZXRhZGF0YUVudHJ5EhcKCmNyZWF0ZWRfYnkYBCABKAlIAIgBARIuCgpjcmVhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBI0CgthcmNoaXZlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAYgBARIYCgthcmNoaXZlZF9ieRgIIAEoCUgCiAEBEjsKEnN0b3JhZ2VfZGVsZXRlZF9hdBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIA4gBARpHCg1NZXRhZGF0YUVudHJ5EgsKA2tleRgBIAEoCRIlCgV2YWx1ZRgCIAEoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZToCOAFCDQoLX2NyZWF0ZWRfYnlCDgoMX2FyY2hpdmVkX2F0Qg4KDF9hcmNoaXZlZF9ieUIVChNfc3RvcmFnZV9kZWxldGVkX2F0ItgDCgxNb2RlbFZlcnNpb24SCgoCaWQYASABKAkSEgoKbW9kZWxfbmFtZRgCIAEoCRIPCgd2ZXJzaW9uGAMgASgEEjYKDm1vZGVsX2FydGlmYWN0GAQgASgLMh4uY2hhbGsuc2VydmVyLnYxLk1vZGVsQXJ0aWZhY3QSDwoHYWxpYXNlcxgFIAMoCRI9CghtZXRhZGF0YRgGIAMoCzIrLmNoYWxrLnNlcnZlci52MS5Nb2RlbFZlcnNpb24uTWV0YWRhdGFFbnRyeRIXCgpjcmVhdGVkX2J5GAcgASgJSACIAQESLgoKY3JlYXRlZF9hdBgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASNAoLYXJjaGl2ZWRfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQESGAoLYXJjaGl2ZWRfYnkYCiABKAlIAogBARpHCg1NZXRhZGF0YUVudHJ5EgsKA2tleRgBIAEoCRIlCgV2YWx1ZRgCIAEoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZToCOAFCDQoLX2NyZWF0ZWRfYnlCDgoMX2FyY2hpdmVkX2F0Qg4KDF9hcmNoaXZlZF9ieSKkBAoFTW9kZWwSCgoCaWQYASABKAkSEgoKbW9kZWxfbmFtZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRI2CghtZXRhZGF0YRgEIAMoCzIkLmNoYWxrLnNlcnZlci52MS5Nb2RlbC5NZXRhZGF0YUVudHJ5EhcKCmNyZWF0ZWRfYnkYBSABKAlIAIgBARIuCgpjcmVhdGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIzCgp1cGRhdGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgBiAEBEjQKC2FyY2hpdmVkX2F0GAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgCiAEBEkAKFGxhdGVzdF9tb2RlbF92ZXJzaW9uGAkgASgLMh0uY2hhbGsuc2VydmVyLnYxLk1vZGVsVmVyc2lvbkgDiAEBEhgKC2FyY2hpdmVkX2J5GAogASgJSASIAQEaRwoNTWV0YWRhdGFFbnRyeRILCgNrZXkYASABKAkSJQoFdmFsdWUYAiABKAsyFi5nb29nbGUucHJvdG9idWYuVmFsdWU6AjgBQg0KC19jcmVhdGVkX2J5Qg0KC191cGRhdGVkX2F0Qg4KDF9hcmNoaXZlZF9hdEIXChVfbGF0ZXN0X21vZGVsX3ZlcnNpb25CDgoMX2FyY2hpdmVkX2J5IogDChFMaXN0TW9kZWxzUmVxdWVzdBITCgZjdXJzb3IYASABKAlIAIgBARISCgVsaW1pdBgCIAEoBUgBiAEBEhwKD2luY2x1ZGVfZGVsZXRlZBgDIAEoCEgCiAEBEhMKBnNlYXJjaBgEIAEoCUgDiAEBEjgKB2ZpbHRlcnMYBSABKAsyIi5jaGFsay5zZXJ2ZXIudjEuTGlzdE1vZGVsc0ZpbHRlcnNIBIgBARI/Cgtzb3J0X2NvbHVtbhgGIAEoDjIlLmNoYWxrLnNlcnZlci52MS5MaXN0TW9kZWxzU29ydENvbHVtbkgFiAEBEj0KCnNvcnRfb3JkZXIYByABKA4yJC5jaGFsay5zZXJ2ZXIudjEuTGlzdE1vZGVsc1NvcnRPcmRlckgGiAEBQgkKB19jdXJzb3JCCAoGX2xpbWl0QhIKEF9pbmNsdWRlX2RlbGV0ZWRCCQoHX3NlYXJjaEIKCghfZmlsdGVyc0IOCgxfc29ydF9jb2x1bW5CDQoLX3NvcnRfb3JkZXIiZgoSTGlzdE1vZGVsc1Jlc3BvbnNlEiYKBm1vZGVscxgBIAMoCzIWLmNoYWxrLnNlcnZlci52MS5Nb2RlbBIYCgtuZXh0X2N1cnNvchgCIAEoCUgAiAEBQg4KDF9uZXh0X2N1cnNvciKBAQoPR2V0TW9kZWxSZXF1ZXN0EhIKCG1vZGVsX2lkGAEgASgJSAASFAoKbW9kZWxfbmFtZRgCIAEoCUgAEhwKD2luY2x1ZGVfZGVsZXRlZBgDIAEoCEgBiAEBQhIKEG1vZGVsX2lkZW50aWZpZXJCEgoQX2luY2x1ZGVfZGVsZXRlZCJIChBHZXRNb2RlbFJlc3BvbnNlEioKBW1vZGVsGAEgASgLMhYuY2hhbGsuc2VydmVyLnYxLk1vZGVsSACIAQFCCAoGX21vZGVsIssBChJDcmVhdGVNb2RlbFJlcXVlc3QSEgoKbW9kZWxfbmFtZRgBIAEoCRITCgtkZXNjcmlwdGlvbhgCIAEoCRJDCghtZXRhZGF0YRgEIAMoCzIxLmNoYWxrLnNlcnZlci52MS5DcmVhdGVNb2RlbFJlcXVlc3QuTWV0YWRhdGFFbnRyeRpHCg1NZXRhZGF0YUVudHJ5EgsKA2tleRgBIAEoCRIlCgV2YWx1ZRgCIAEoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZToCOAEiPAoTQ3JlYXRlTW9kZWxSZXNwb25zZRIlCgVtb2RlbBgBIAEoCzIWLmNoYWxrLnNlcnZlci52MS5Nb2RlbCLCAgoUVXBkYXRlTW9kZWxPcGVyYXRpb24SFwoKbW9kZWxfbmFtZRgBIAEoCUgAiAEBEhgKC2Rlc2NyaXB0aW9uGAIgASgJSAGIAQESRQoIbWV0YWRhdGEYAyADKAsyMy5jaGFsay5zZXJ2ZXIudjEuVXBkYXRlTW9kZWxPcGVyYXRpb24uTWV0YWRhdGFFbnRyeRI4CgthcmNoaXZlZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCAhgBSAKIAQEaRwoNTWV0YWRhdGFFbnRyeRILCgNrZXkYASABKAkSJQoFdmFsdWUYAiABKAsyFi5nb29nbGUucHJvdG9idWYuVmFsdWU6AjgBQg0KC19tb2RlbF9uYW1lQg4KDF9kZXNjcmlwdGlvbkIOCgxfYXJjaGl2ZWRfYXQijgEKElVwZGF0ZU1vZGVsUmVxdWVzdBIQCghtb2RlbF9pZBgBIAEoCRI1CgZ1cGRhdGUYAiABKAsyJS5jaGFsay5zZXJ2ZXIudjEuVXBkYXRlTW9kZWxPcGVyYXRpb24SLwoLdXBkYXRlX21hc2sYAyABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrIjwKE1VwZGF0ZU1vZGVsUmVzcG9uc2USJQoFbW9kZWwYASABKAsyFi5jaGFsay5zZXJ2ZXIudjEuTW9kZWwiUgoSRGVsZXRlTW9kZWxSZXF1ZXN0EhIKCG1vZGVsX2lkGAEgASgJSAASFAoKbW9kZWxfbmFtZRgCIAEoCUgAQhIKEG1vZGVsX2lkZW50aWZpZXIiPAoTRGVsZXRlTW9kZWxSZXNwb25zZRIlCgVtb2RlbBgBIAEoCzIWLmNoYWxrLnNlcnZlci52MS5Nb2RlbCJbChhMaXN0TW9kZWxWZXJzaW9uc0ZpbHRlcnMSDwoHYWxpYXNlcxgBIAMoCRISCgphdXRob3JfaWRzGAIgAygJEhoKEm1vZGVsX2FydGlmYWN0X2lkcxgDIAMoCSL/AQoYTGlzdE1vZGVsVmVyc2lvbnNSZXF1ZXN0EhcKCm1vZGVsX25hbWUYASABKAlIAIgBARITCgZjdXJzb3IYAiABKAlIAYgBARISCgVsaW1pdBgDIAEoBUgCiAEBEhwKD2luY2x1ZGVfZGVsZXRlZBgEIAEoCEgDiAEBEj8KB2ZpbHRlcnMYBSABKAsyKS5jaGFsay5zZXJ2ZXIudjEuTGlzdE1vZGVsVmVyc2lvbnNGaWx0ZXJzSASIAQFCDQoLX21vZGVsX25hbWVCCQoHX2N1cnNvckIICgZfbGltaXRCEgoQX2luY2x1ZGVfZGVsZXRlZEIKCghfZmlsdGVycyJ8ChlMaXN0TW9kZWxWZXJzaW9uc1Jlc3BvbnNlEjUKDm1vZGVsX3ZlcnNpb25zGAEgAygLMh0uY2hhbGsuc2VydmVyLnYxLk1vZGVsVmVyc2lvbhIYCgtuZXh0X2N1cnNvchgCIAEoCUgAiAEBQg4KDF9uZXh0X2N1cnNvciJvChZHZXRNb2RlbFZlcnNpb25SZXF1ZXN0EhIKCm1vZGVsX25hbWUYASABKAkSDwoHdmVyc2lvbhgCIAEoBBIcCg9pbmNsdWRlX2RlbGV0ZWQYAyABKAhIAIgBAUISChBfaW5jbHVkZV9kZWxldGVkImYKF0dldE1vZGVsVmVyc2lvblJlc3BvbnNlEjkKDW1vZGVsX3ZlcnNpb24YASABKAsyHS5jaGFsay5zZXJ2ZXIudjEuTW9kZWxWZXJzaW9uSACIAQFCEAoOX21vZGVsX3ZlcnNpb24iiQIKGkNyZWF0ZU1vZGVsQXJ0aWZhY3RSZXF1ZXN0EhkKEW1vZGVsX2FydGlmYWN0X2lkGAUgASgJEjoKDm1vZGVsX2FydGlmYWN0GAIgASgLMiIuY2hhbGsubW9kZWxzLnYxLk1vZGVsQXJ0aWZhY3RTcGVjEksKCG1ldGFkYXRhGAQgAygLMjkuY2hhbGsuc2VydmVyLnYxLkNyZWF0ZU1vZGVsQXJ0aWZhY3RSZXF1ZXN0Lk1ldGFkYXRhRW50cnkaRwoNTWV0YWRhdGFFbnRyeRILCgNrZXkYASABKAkSJQoFdmFsdWUYAiABKAsyFi5nb29nbGUucHJvdG9idWYuVmFsdWU6AjgBIlUKG0NyZWF0ZU1vZGVsQXJ0aWZhY3RSZXNwb25zZRI2Cg5tb2RlbF9hcnRpZmFjdBgBIAEoCzIeLmNoYWxrLnNlcnZlci52MS5Nb2RlbEFydGlmYWN0IqwCChlDcmVhdGVNb2RlbFZlcnNpb25SZXF1ZXN0EhIKCm1vZGVsX25hbWUYASABKAkSGQoRbW9kZWxfYXJ0aWZhY3RfaWQYBSABKAkSOgoObW9kZWxfYXJ0aWZhY3QYAiABKAsyIi5jaGFsay5tb2RlbHMudjEuTW9kZWxBcnRpZmFjdFNwZWMSDwoHYWxpYXNlcxgDIAMoCRJKCghtZXRhZGF0YRgEIAMoCzI4LmNoYWxrLnNlcnZlci52MS5DcmVhdGVNb2RlbFZlcnNpb25SZXF1ZXN0Lk1ldGFkYXRhRW50cnkaRwoNTWV0YWRhdGFFbnRyeRILCgNrZXkYASABKAkSJQoFdmFsdWUYAiABKAsyFi5nb29nbGUucHJvdG9idWYuVmFsdWU6AjgBIlIKGkNyZWF0ZU1vZGVsVmVyc2lvblJlc3BvbnNlEjQKDW1vZGVsX3ZlcnNpb24YASABKAsyHS5jaGFsay5zZXJ2ZXIudjEuTW9kZWxWZXJzaW9uIjYKD01vZGVsVmVyc2lvbktleRISCgptb2RlbF9uYW1lGAEgASgJEg8KB3ZlcnNpb24YAiABKAQixQEKG1VwZGF0ZU1vZGVsVmVyc2lvbk9wZXJhdGlvbhIPCgdhbGlhc2VzGAEgAygJEkwKCG1ldGFkYXRhGAIgAygLMjouY2hhbGsuc2VydmVyLnYxLlVwZGF0ZU1vZGVsVmVyc2lvbk9wZXJhdGlvbi5NZXRhZGF0YUVudHJ5GkcKDU1ldGFkYXRhRW50cnkSCwoDa2V5GAEgASgJEiUKBXZhbHVlGAIgASgLMhYuZ29vZ2xlLnByb3RvYnVmLlZhbHVlOgI4ASLHAQoZVXBkYXRlTW9kZWxWZXJzaW9uUmVxdWVzdBI7ChFtb2RlbF92ZXJzaW9uX2tleRgBIAEoCzIgLmNoYWxrLnNlcnZlci52MS5Nb2RlbFZlcnNpb25LZXkSPAoGdXBkYXRlGAIgASgLMiwuY2hhbGsuc2VydmVyLnYxLlVwZGF0ZU1vZGVsVmVyc2lvbk9wZXJhdGlvbhIvCgt1cGRhdGVfbWFzaxgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2siUgoaVXBkYXRlTW9kZWxWZXJzaW9uUmVzcG9uc2USNAoNbW9kZWxfdmVyc2lvbhgBIAEoCzIdLmNoYWxrLnNlcnZlci52MS5Nb2RlbFZlcnNpb24iWAoZRGVsZXRlTW9kZWxWZXJzaW9uUmVxdWVzdBI7ChFtb2RlbF92ZXJzaW9uX2tleRgBIAEoCzIgLmNoYWxrLnNlcnZlci52MS5Nb2RlbFZlcnNpb25LZXkiUgoaRGVsZXRlTW9kZWxWZXJzaW9uUmVzcG9uc2USNAoNbW9kZWxfdmVyc2lvbhgBIAEoCzIdLmNoYWxrLnNlcnZlci52MS5Nb2RlbFZlcnNpb24iNwohR2V0TW9kZWxBcnRpZmFjdFVwbG9hZFVybHNSZXF1ZXN0EhIKCmZpbGVfbmFtZXMYASADKAkizAEKIkdldE1vZGVsQXJ0aWZhY3RVcGxvYWRVcmxzUmVzcG9uc2USWAoLdXBsb2FkX3VybHMYASADKAsyQy5jaGFsay5zZXJ2ZXIudjEuR2V0TW9kZWxBcnRpZmFjdFVwbG9hZFVybHNSZXNwb25zZS5VcGxvYWRVcmxzRW50cnkSGQoRbW9kZWxfYXJ0aWZhY3RfaWQYAiABKAkaMQoPVXBsb2FkVXJsc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEikQEKHERvd25sb2FkTW9kZWxBcnRpZmFjdFJlcXVlc3QSOwoRbW9kZWxfdmVyc2lvbl9rZXkYASABKAsyIC5jaGFsay5zZXJ2ZXIudjEuTW9kZWxWZXJzaW9uS2V5Eh4KEW1vZGVsX2FydGlmYWN0X2lkGAIgASgJSACIAQFCFAoSX21vZGVsX2FydGlmYWN0X2lkIpoBCh1Eb3dubG9hZE1vZGVsQXJ0aWZhY3RSZXNwb25zZRIPCgN1cmkYASABKAlCAhgBEjYKDm1vZGVsX2FydGlmYWN0GAIgASgLMh4uY2hhbGsuc2VydmVyLnYxLk1vZGVsQXJ0aWZhY3QSEgoKbW9kZWxfdXJscxgDIAMoCRIcChRhZGRpdGlvbmFsX2ZpbGVfdXJscxgEIAMoCSLGAQoZR2V0TW9kZWxSZWZlcmVuY2VzUmVxdWVzdBIVCg1kZXBsb3ltZW50X2lkGAEgASgJEhcKCm1vZGVsX25hbWUYAiABKAlIAIgBARIaCg1tb2RlbF92ZXJzaW9uGAMgASgNSAGIAQESEwoGY3Vyc29yGAQgASgJSAKIAQESEgoFbGltaXQYBSABKAVIA4gBAUINCgtfbW9kZWxfbmFtZUIQCg5fbW9kZWxfdmVyc2lvbkIJCgdfY3Vyc29yQggKBl9saW1pdCI/Cg1Nb2RlbFJlbGF0aW9uEhYKDmlucHV0X2ZlYXR1cmVzGAEgAygJEhYKDm91dHB1dF9mZWF0dXJlGAIgASgJIrECCg5Nb2RlbFJlZmVyZW5jZRIKCgJpZBgBIAEoCRISCgptb2RlbF9uYW1lGAIgASgJEg8KB3ZlcnNpb24YAyABKAQSFQoNZGVwbG95bWVudF9pZBgEIAEoCRIxCglyZWxhdGlvbnMYBSADKAsyHi5jaGFsay5zZXJ2ZXIudjEuTW9kZWxSZWxhdGlvbhIRCglyZXNvbHZlcnMYBiADKAkSRwoVc291cmNlX2ZpbGVfcmVmZXJlbmNlGAcgASgLMiMuY2hhbGsuZ3JhcGgudjEuU291cmNlRmlsZVJlZmVyZW5jZUgAiAEBEi4KCmNyZWF0ZWRfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQhgKFl9zb3VyY2VfZmlsZV9yZWZlcmVuY2UigQEKGkdldE1vZGVsUmVmZXJlbmNlc1Jlc3BvbnNlEjkKEG1vZGVsX3JlZmVyZW5jZXMYASADKAsyHy5jaGFsay5zZXJ2ZXIudjEuTW9kZWxSZWZlcmVuY2USGAoLbmV4dF9jdXJzb3IYBCABKAlIAIgBAUIOCgxfbmV4dF9jdXJzb3IicgoYR2V0TW9kZWxSZWZlcmVuY2VSZXF1ZXN0EhQKCG1vZGVsX2lkGAEgASgJQgIYARISCgptb2RlbF9uYW1lGAQgASgJEhUKDW1vZGVsX3ZlcnNpb24YAiABKAQSFQoNZGVwbG95bWVudF9pZBgDIAEoCSJuChlHZXRNb2RlbFJlZmVyZW5jZVJlc3BvbnNlEj0KD21vZGVsX3JlZmVyZW5jZRgBIAEoCzIfLmNoYWxrLnNlcnZlci52MS5Nb2RlbFJlZmVyZW5jZUgAiAEBQhIKEF9tb2RlbF9yZWZlcmVuY2UitAEKDFJ1bkNyaXRlcmlvbhIQCgZydW5faWQYASABKAlIABISCghydW5fbmFtZRgEIAEoCUgAEhMKBm1ldHJpYxgCIAEoCUgBiAEBEj4KCWRpcmVjdGlvbhgDIAEoDjImLmNoYWxrLnNlcnZlci52MS5SdW5Dcml0ZXJpb25EaXJlY3Rpb25IAogBAUIQCg5ydW5faWRlbnRpZmllckIJCgdfbWV0cmljQgwKCl9kaXJlY3Rpb24ijwEKJkNyZWF0ZU1vZGVsVmVyc2lvbkZyb21BcnRpZmFjdE92ZXJyaWRlEjAKBHNwZWMYASABKAsyIi5jaGFsay5tb2RlbHMudjEuTW9kZWxBcnRpZmFjdFNwZWMSMwoPb3ZlcnJpZGVfZmllbGRzGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzayKUAgolQ3JlYXRlTW9kZWxWZXJzaW9uRnJvbUFydGlmYWN0UmVxdWVzdBISCgptb2RlbF9uYW1lGAEgASgJEhsKEW1vZGVsX2FydGlmYWN0X2lkGAIgASgJSAASNQoMdHJhaW5pbmdfcnVuGAMgASgLMh0uY2hhbGsuc2VydmVyLnYxLlJ1bkNyaXRlcmlvbkgAEg8KB2FsaWFzZXMYBCADKAkSTgoIb3ZlcnJpZGUYBSABKAsyNy5jaGFsay5zZXJ2ZXIudjEuQ3JlYXRlTW9kZWxWZXJzaW9uRnJvbUFydGlmYWN0T3ZlcnJpZGVIAYgBAUIVChNhcnRpZmFjdF9pZGVudGlmaWVyQgsKCV9vdmVycmlkZSJeCiZDcmVhdGVNb2RlbFZlcnNpb25Gcm9tQXJ0aWZhY3RSZXNwb25zZRI0Cg1tb2RlbF92ZXJzaW9uGAEgASgLMh0uY2hhbGsuc2VydmVyLnYxLk1vZGVsVmVyc2lvbiLVAQoZTGlzdE1vZGVsQXJ0aWZhY3RzUmVxdWVzdBIYCg5zY3JpcHRfdGFza19pZBgBIAEoCUgAEhkKD3RyYWluaW5nX3J1bl9pZBgEIAEoCUgAEhMKBmN1cnNvchgCIAEoCUgBiAEBEhIKBWxpbWl0GAMgASgFSAKIAQESOwoHZmlsdGVycxgFIAEoCzIqLmNoYWxrLnNlcnZlci52MS5MaXN0TW9kZWxBcnRpZmFjdHNGaWx0ZXJzQggKBmZpbHRlckIJCgdfY3Vyc29yQggKBl9saW1pdCIvChlMaXN0TW9kZWxBcnRpZmFjdHNGaWx0ZXJzEhIKCmNyZWF0ZWRfYnkYASADKAkifwoaTGlzdE1vZGVsQXJ0aWZhY3RzUmVzcG9uc2USNwoPbW9kZWxfYXJ0aWZhY3RzGAEgAygLMh4uY2hhbGsuc2VydmVyLnYxLk1vZGVsQXJ0aWZhY3QSGAoLbmV4dF9jdXJzb3IYAiABKAlIAIgBAUIOCgxfbmV4dF9jdXJzb3IiNAoXR2V0TW9kZWxBcnRpZmFjdFJlcXVlc3QSGQoRbW9kZWxfYXJ0aWZhY3RfaWQYASABKAkiagoYR2V0TW9kZWxBcnRpZmFjdFJlc3BvbnNlEjsKDm1vZGVsX2FydGlmYWN0GAEgASgLMh4uY2hhbGsuc2VydmVyLnYxLk1vZGVsQXJ0aWZhY3RIAIgBAUIRCg9fbW9kZWxfYXJ0aWZhY3QiXAoRTGlzdE1vZGVsc0ZpbHRlcnMSMwoIc3RhdHVzZXMYASADKA4yIS5jaGFsay5zZXJ2ZXIudjEuTGlzdE1vZGVsc1N0YXR1cxISCgpjcmVhdGVkX2J5GAIgAygJKoIBChVSdW5Dcml0ZXJpb25EaXJlY3Rpb24SJwojUlVOX0NSSVRFUklPTl9ESVJFQ1RJT05fVU5TUEVDSUZJRUQQABIfChtSVU5fQ1JJVEVSSU9OX0RJUkVDVElPTl9NQVgQARIfChtSVU5fQ1JJVEVSSU9OX0RJUkVDVElPTl9NSU4QAiqxAQoUTGlzdE1vZGVsc1NvcnRDb2x1bW4SJwojTElTVF9NT0RFTFNfU09SVF9DT0xVTU5fVU5TUEVDSUZJRUQQABIgChxMSVNUX01PREVMU19TT1JUX0NPTFVNTl9OQU1FEAESJgoiTElTVF9NT0RFTFNfU09SVF9DT0xVTU5fQ1JFQVRFRF9BVBACEiYKIkxJU1RfTU9ERUxTX1NPUlRfQ09MVU1OX1VQREFURURfQVQQAyqKAQoTTGlzdE1vZGVsc1NvcnRPcmRlchImCiJMSVNUX01PREVMU19TT1JUX09SREVSX1VOU1BFQ0lGSUVEEAASJAogTElTVF9NT0RFTFNfU09SVF9PUkRFUl9BU0NFTkRJTkcQARIlCiFMSVNUX01PREVMU19TT1JUX09SREVSX0RFU0NFTkRJTkcQAip1ChBMaXN0TW9kZWxzU3RhdHVzEiIKHkxJU1RfTU9ERUxTX1NUQVRVU19VTlNQRUNJRklFRBAAEh0KGUxJU1RfTU9ERUxTX1NUQVRVU19BQ1RJVkUQARIeChpMSVNUX01PREVMU19TVEFUVVNfREVMRVRFRBACMrUWChRNb2RlbFJlZ2lzdHJ5U2VydmljZRJdCgpMaXN0TW9kZWxzEiIuY2hhbGsuc2VydmVyLnYxLkxpc3RNb2RlbHNSZXF1ZXN0GiMuY2hhbGsuc2VydmVyLnYxLkxpc3RNb2RlbHNSZXNwb25zZSIGkAIBgH0LElcKCEdldE1vZGVsEiAuY2hhbGsuc2VydmVyLnYxLkdldE1vZGVsUmVxdWVzdBohLmNoYWxrLnNlcnZlci52MS5HZXRNb2RlbFJlc3BvbnNlIgaQAgGAfQsStAEKC0NyZWF0ZU1vZGVsEiMuY2hhbGsuc2VydmVyLnYxLkNyZWF0ZU1vZGVsUmVxdWVzdBokLmNoYWxrLnNlcnZlci52MS5DcmVhdGVNb2RlbFJlc3BvbnNlIlqAfQyS0w5TChZtb2RlbF9yZWdpc3RyeV9lbmFibGVkEjlUaGlzIGFjdGlvbiBpcyBub3QgZW5hYmxlZC4gUGxlYXNlIGNvbnRhY3QgQ2hhbGsgU3VwcG9ydC4StAEKC1VwZGF0ZU1vZGVsEiMuY2hhbGsuc2VydmVyLnYxLlVwZGF0ZU1vZGVsUmVxdWVzdBokLmNoYWxrLnNlcnZlci52MS5VcGRhdGVNb2RlbFJlc3BvbnNlIlqAfQyS0w5TChZtb2RlbF9yZWdpc3RyeV9lbmFibGVkEjlUaGlzIGFjdGlvbiBpcyBub3QgZW5hYmxlZC4gUGxlYXNlIGNvbnRhY3QgQ2hhbGsgU3VwcG9ydC4StwEKC0RlbGV0ZU1vZGVsEiMuY2hhbGsuc2VydmVyLnYxLkRlbGV0ZU1vZGVsUmVxdWVzdBokLmNoYWxrLnNlcnZlci52MS5EZWxldGVNb2RlbFJlc3BvbnNlIl2QAgKAfQyS0w5TChZtb2RlbF9yZWdpc3RyeV9lbmFibGVkEjlUaGlzIGFjdGlvbiBpcyBub3QgZW5hYmxlZC4gUGxlYXNlIGNvbnRhY3QgQ2hhbGsgU3VwcG9ydC4ScgoRTGlzdE1vZGVsVmVyc2lvbnMSKS5jaGFsay5zZXJ2ZXIudjEuTGlzdE1vZGVsVmVyc2lvbnNSZXF1ZXN0GiouY2hhbGsuc2VydmVyLnYxLkxpc3RNb2RlbFZlcnNpb25zUmVzcG9uc2UiBpACAYB9CxJsCg9HZXRNb2RlbFZlcnNpb24SJy5jaGFsay5zZXJ2ZXIudjEuR2V0TW9kZWxWZXJzaW9uUmVxdWVzdBooLmNoYWxrLnNlcnZlci52MS5HZXRNb2RlbFZlcnNpb25SZXNwb25zZSIGkAIBgH0LEskBChJDcmVhdGVNb2RlbFZlcnNpb24SKi5jaGFsay5zZXJ2ZXIudjEuQ3JlYXRlTW9kZWxWZXJzaW9uUmVxdWVzdBorLmNoYWxrLnNlcnZlci52MS5DcmVhdGVNb2RlbFZlcnNpb25SZXNwb25zZSJagH0MktMOUwoWbW9kZWxfcmVnaXN0cnlfZW5hYmxlZBI5VGhpcyBhY3Rpb24gaXMgbm90IGVuYWJsZWQuIFBsZWFzZSBjb250YWN0IENoYWxrIFN1cHBvcnQuEswBChNDcmVhdGVNb2RlbEFydGlmYWN0EisuY2hhbGsuc2VydmVyLnYxLkNyZWF0ZU1vZGVsQXJ0aWZhY3RSZXF1ZXN0GiwuY2hhbGsuc2VydmVyLnYxLkNyZWF0ZU1vZGVsQXJ0aWZhY3RSZXNwb25zZSJagH0MktMOUwoWbW9kZWxfcmVnaXN0cnlfZW5hYmxlZBI5VGhpcyBhY3Rpb24gaXMgbm90IGVuYWJsZWQuIFBsZWFzZSBjb250YWN0IENoYWxrIFN1cHBvcnQuEu0BCh5DcmVhdGVNb2RlbFZlcnNpb25Gcm9tQXJ0aWZhY3QSNi5jaGFsay5zZXJ2ZXIudjEuQ3JlYXRlTW9kZWxWZXJzaW9uRnJvbUFydGlmYWN0UmVxdWVzdBo3LmNoYWxrLnNlcnZlci52MS5DcmVhdGVNb2RlbFZlcnNpb25Gcm9tQXJ0aWZhY3RSZXNwb25zZSJagH0MktMOUwoWbW9kZWxfcmVnaXN0cnlfZW5hYmxlZBI5VGhpcyBhY3Rpb24gaXMgbm90IGVuYWJsZWQuIFBsZWFzZSBjb250YWN0IENoYWxrIFN1cHBvcnQuEnIKElVwZGF0ZU1vZGVsVmVyc2lvbhIqLmNoYWxrLnNlcnZlci52MS5VcGRhdGVNb2RlbFZlcnNpb25SZXF1ZXN0GisuY2hhbGsuc2VydmVyLnYxLlVwZGF0ZU1vZGVsVmVyc2lvblJlc3BvbnNlIgOAfQwSzAEKEkRlbGV0ZU1vZGVsVmVyc2lvbhIqLmNoYWxrLnNlcnZlci52MS5EZWxldGVNb2RlbFZlcnNpb25SZXF1ZXN0GisuY2hhbGsuc2VydmVyLnYxLkRlbGV0ZU1vZGVsVmVyc2lvblJlc3BvbnNlIl2QAgKAfQyS0w5TChZtb2RlbF9yZWdpc3RyeV9lbmFibGVkEjlUaGlzIGFjdGlvbiBpcyBub3QgZW5hYmxlZC4gUGxlYXNlIGNvbnRhY3QgQ2hhbGsgU3VwcG9ydC4S1QEKFURvd25sb2FkTW9kZWxBcnRpZmFjdBItLmNoYWxrLnNlcnZlci52MS5Eb3dubG9hZE1vZGVsQXJ0aWZhY3RSZXF1ZXN0Gi4uY2hhbGsuc2VydmVyLnYxLkRvd25sb2FkTW9kZWxBcnRpZmFjdFJlc3BvbnNlIl2QAgGAfQuS0w5TChZtb2RlbF9yZWdpc3RyeV9lbmFibGVkEjlUaGlzIGFjdGlvbiBpcyBub3QgZW5hYmxlZC4gUGxlYXNlIGNvbnRhY3QgQ2hhbGsgU3VwcG9ydC4SdQoSR2V0TW9kZWxSZWZlcmVuY2VzEiouY2hhbGsuc2VydmVyLnYxLkdldE1vZGVsUmVmZXJlbmNlc1JlcXVlc3QaKy5jaGFsay5zZXJ2ZXIudjEuR2V0TW9kZWxSZWZlcmVuY2VzUmVzcG9uc2UiBpACAYB9CxJyChFHZXRNb2RlbFJlZmVyZW5jZRIpLmNoYWxrLnNlcnZlci52MS5HZXRNb2RlbFJlZmVyZW5jZVJlcXVlc3QaKi5jaGFsay5zZXJ2ZXIudjEuR2V0TW9kZWxSZWZlcmVuY2VSZXNwb25zZSIGkAIBgH0LEuEBChpHZXRNb2RlbEFydGlmYWN0VXBsb2FkVXJscxIyLmNoYWxrLnNlcnZlci52MS5HZXRNb2RlbEFydGlmYWN0VXBsb2FkVXJsc1JlcXVlc3QaMy5jaGFsay5zZXJ2ZXIudjEuR2V0TW9kZWxBcnRpZmFjdFVwbG9hZFVybHNSZXNwb25zZSJagH0MktMOUwoWbW9kZWxfcmVnaXN0cnlfZW5hYmxlZBI5VGhpcyBhY3Rpb24gaXMgbm90IGVuYWJsZWQuIFBsZWFzZSBjb250YWN0IENoYWxrIFN1cHBvcnQuEnUKEkxpc3RNb2RlbEFydGlmYWN0cxIqLmNoYWxrLnNlcnZlci52MS5MaXN0TW9kZWxBcnRpZmFjdHNSZXF1ZXN0GisuY2hhbGsuc2VydmVyLnYxLkxpc3RNb2RlbEFydGlmYWN0c1Jlc3BvbnNlIgaQAgGAfQsSbwoQR2V0TW9kZWxBcnRpZmFjdBIoLmNoYWxrLnNlcnZlci52MS5HZXRNb2RlbEFydGlmYWN0UmVxdWVzdBopLmNoYWxrLnNlcnZlci52MS5HZXRNb2RlbEFydGlmYWN0UmVzcG9uc2UiBpACAYB9C0IUWhJzZXJ2ZXIvdjE7c2VydmVydjFiBnByb3RvMw", [file_chalk_auth_v1_permissions, file_chalk_flags_v1_flags, file_chalk_graph_v1_source_file_reference, file_chalk_models_v1_model_artifact, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.ModelArtifact
 */
export type ModelArtifact = Message<"chalk.server.v1.ModelArtifact"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * @generated from field: chalk.models.v1.ModelArtifactSpec spec = 3;
   */
  spec?: ModelArtifactSpec;

  /**
   * @generated from field: map<string, google.protobuf.Value> metadata = 6;
   */
  metadata: { [key: string]: Value };

  /**
   * @generated from field: optional string created_by = 4;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 7;
   */
  archivedAt?: Timestamp;

  /**
   * @generated from field: optional string archived_by = 8;
   */
  archivedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp storage_deleted_at = 9;
   */
  storageDeletedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.ModelArtifact.
 * Use `create(ModelArtifactSchema)` to create a new message.
 */
export const ModelArtifactSchema: GenMessage<ModelArtifact> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 0);

/**
 * @generated from message chalk.server.v1.ModelVersion
 */
export type ModelVersion = Message<"chalk.server.v1.ModelVersion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string model_name = 2;
   */
  modelName: string;

  /**
   * @generated from field: uint64 version = 3;
   */
  version: bigint;

  /**
   * @generated from field: chalk.server.v1.ModelArtifact model_artifact = 4;
   */
  modelArtifact?: ModelArtifact;

  /**
   * @generated from field: repeated string aliases = 5;
   */
  aliases: string[];

  /**
   * soft-deprecated
   *
   * @generated from field: map<string, google.protobuf.Value> metadata = 6;
   */
  metadata: { [key: string]: Value };

  /**
   * @generated from field: optional string created_by = 7;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 9;
   */
  archivedAt?: Timestamp;

  /**
   * @generated from field: optional string archived_by = 10;
   */
  archivedBy?: string;
};

/**
 * Describes the message chalk.server.v1.ModelVersion.
 * Use `create(ModelVersionSchema)` to create a new message.
 */
export const ModelVersionSchema: GenMessage<ModelVersion> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 1);

/**
 * @generated from message chalk.server.v1.Model
 */
export type Model = Message<"chalk.server.v1.Model"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string model_name = 2;
   */
  modelName: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> metadata = 4;
   */
  metadata: { [key: string]: Value };

  /**
   * @generated from field: optional string created_by = 5;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 8;
   */
  archivedAt?: Timestamp;

  /**
   * @generated from field: optional chalk.server.v1.ModelVersion latest_model_version = 9;
   */
  latestModelVersion?: ModelVersion;

  /**
   * @generated from field: optional string archived_by = 10;
   */
  archivedBy?: string;
};

/**
 * Describes the message chalk.server.v1.Model.
 * Use `create(ModelSchema)` to create a new message.
 */
export const ModelSchema: GenMessage<Model> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 2);

/**
 * @generated from message chalk.server.v1.ListModelsRequest
 */
export type ListModelsRequest = Message<"chalk.server.v1.ListModelsRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional bool include_deleted = 3;
   */
  includeDeleted?: boolean;

  /**
   * @generated from field: optional string search = 4;
   */
  search?: string;

  /**
   * @generated from field: optional chalk.server.v1.ListModelsFilters filters = 5;
   */
  filters?: ListModelsFilters;

  /**
   * @generated from field: optional chalk.server.v1.ListModelsSortColumn sort_column = 6;
   */
  sortColumn?: ListModelsSortColumn;

  /**
   * @generated from field: optional chalk.server.v1.ListModelsSortOrder sort_order = 7;
   */
  sortOrder?: ListModelsSortOrder;
};

/**
 * Describes the message chalk.server.v1.ListModelsRequest.
 * Use `create(ListModelsRequestSchema)` to create a new message.
 */
export const ListModelsRequestSchema: GenMessage<ListModelsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 3);

/**
 * @generated from message chalk.server.v1.ListModelsResponse
 */
export type ListModelsResponse = Message<"chalk.server.v1.ListModelsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.Model models = 1;
   */
  models: Model[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListModelsResponse.
 * Use `create(ListModelsResponseSchema)` to create a new message.
 */
export const ListModelsResponseSchema: GenMessage<ListModelsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 4);

/**
 * @generated from message chalk.server.v1.GetModelRequest
 */
export type GetModelRequest = Message<"chalk.server.v1.GetModelRequest"> & {
  /**
   * @generated from oneof chalk.server.v1.GetModelRequest.model_identifier
   */
  modelIdentifier: {
    /**
     * @generated from field: string model_id = 1;
     */
    value: string;
    case: "modelId";
  } | {
    /**
     * @generated from field: string model_name = 2;
     */
    value: string;
    case: "modelName";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional bool include_deleted = 3;
   */
  includeDeleted?: boolean;
};

/**
 * Describes the message chalk.server.v1.GetModelRequest.
 * Use `create(GetModelRequestSchema)` to create a new message.
 */
export const GetModelRequestSchema: GenMessage<GetModelRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 5);

/**
 * @generated from message chalk.server.v1.GetModelResponse
 */
export type GetModelResponse = Message<"chalk.server.v1.GetModelResponse"> & {
  /**
   * @generated from field: optional chalk.server.v1.Model model = 1;
   */
  model?: Model;
};

/**
 * Describes the message chalk.server.v1.GetModelResponse.
 * Use `create(GetModelResponseSchema)` to create a new message.
 */
export const GetModelResponseSchema: GenMessage<GetModelResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 6);

/**
 * @generated from message chalk.server.v1.CreateModelRequest
 */
export type CreateModelRequest = Message<"chalk.server.v1.CreateModelRequest"> & {
  /**
   * @generated from field: string model_name = 1;
   */
  modelName: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> metadata = 4;
   */
  metadata: { [key: string]: Value };
};

/**
 * Describes the message chalk.server.v1.CreateModelRequest.
 * Use `create(CreateModelRequestSchema)` to create a new message.
 */
export const CreateModelRequestSchema: GenMessage<CreateModelRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 7);

/**
 * @generated from message chalk.server.v1.CreateModelResponse
 */
export type CreateModelResponse = Message<"chalk.server.v1.CreateModelResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Model model = 1;
   */
  model?: Model;
};

/**
 * Describes the message chalk.server.v1.CreateModelResponse.
 * Use `create(CreateModelResponseSchema)` to create a new message.
 */
export const CreateModelResponseSchema: GenMessage<CreateModelResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 8);

/**
 * @generated from message chalk.server.v1.UpdateModelOperation
 */
export type UpdateModelOperation = Message<"chalk.server.v1.UpdateModelOperation"> & {
  /**
   * @generated from field: optional string model_name = 1;
   */
  modelName?: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> metadata = 3;
   */
  metadata: { [key: string]: Value };

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 4 [deprecated = true];
   * @deprecated
   */
  archivedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.UpdateModelOperation.
 * Use `create(UpdateModelOperationSchema)` to create a new message.
 */
export const UpdateModelOperationSchema: GenMessage<UpdateModelOperation> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 9);

/**
 * @generated from message chalk.server.v1.UpdateModelRequest
 */
export type UpdateModelRequest = Message<"chalk.server.v1.UpdateModelRequest"> & {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId: string;

  /**
   * @generated from field: chalk.server.v1.UpdateModelOperation update = 2;
   */
  update?: UpdateModelOperation;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.UpdateModelRequest.
 * Use `create(UpdateModelRequestSchema)` to create a new message.
 */
export const UpdateModelRequestSchema: GenMessage<UpdateModelRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 10);

/**
 * @generated from message chalk.server.v1.UpdateModelResponse
 */
export type UpdateModelResponse = Message<"chalk.server.v1.UpdateModelResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Model model = 1;
   */
  model?: Model;
};

/**
 * Describes the message chalk.server.v1.UpdateModelResponse.
 * Use `create(UpdateModelResponseSchema)` to create a new message.
 */
export const UpdateModelResponseSchema: GenMessage<UpdateModelResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 11);

/**
 * @generated from message chalk.server.v1.DeleteModelRequest
 */
export type DeleteModelRequest = Message<"chalk.server.v1.DeleteModelRequest"> & {
  /**
   * @generated from oneof chalk.server.v1.DeleteModelRequest.model_identifier
   */
  modelIdentifier: {
    /**
     * @generated from field: string model_id = 1;
     */
    value: string;
    case: "modelId";
  } | {
    /**
     * @generated from field: string model_name = 2;
     */
    value: string;
    case: "modelName";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.DeleteModelRequest.
 * Use `create(DeleteModelRequestSchema)` to create a new message.
 */
export const DeleteModelRequestSchema: GenMessage<DeleteModelRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 12);

/**
 * @generated from message chalk.server.v1.DeleteModelResponse
 */
export type DeleteModelResponse = Message<"chalk.server.v1.DeleteModelResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Model model = 1;
   */
  model?: Model;
};

/**
 * Describes the message chalk.server.v1.DeleteModelResponse.
 * Use `create(DeleteModelResponseSchema)` to create a new message.
 */
export const DeleteModelResponseSchema: GenMessage<DeleteModelResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 13);

/**
 * @generated from message chalk.server.v1.ListModelVersionsFilters
 */
export type ListModelVersionsFilters = Message<"chalk.server.v1.ListModelVersionsFilters"> & {
  /**
   * Match versions carrying any of these aliases.
   *
   * @generated from field: repeated string aliases = 1;
   */
  aliases: string[];

  /**
   * Match versions created by any of these user or service-token ids.
   *
   * @generated from field: repeated string author_ids = 2;
   */
  authorIds: string[];

  /**
   * Match versions associated with any of these model artifacts.
   *
   * @generated from field: repeated string model_artifact_ids = 3;
   */
  modelArtifactIds: string[];
};

/**
 * Describes the message chalk.server.v1.ListModelVersionsFilters.
 * Use `create(ListModelVersionsFiltersSchema)` to create a new message.
 */
export const ListModelVersionsFiltersSchema: GenMessage<ListModelVersionsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 14);

/**
 * @generated from message chalk.server.v1.ListModelVersionsRequest
 */
export type ListModelVersionsRequest = Message<"chalk.server.v1.ListModelVersionsRequest"> & {
  /**
   * @generated from field: optional string model_name = 1;
   */
  modelName?: string;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: optional bool include_deleted = 4;
   */
  includeDeleted?: boolean;

  /**
   * @generated from field: optional chalk.server.v1.ListModelVersionsFilters filters = 5;
   */
  filters?: ListModelVersionsFilters;
};

/**
 * Describes the message chalk.server.v1.ListModelVersionsRequest.
 * Use `create(ListModelVersionsRequestSchema)` to create a new message.
 */
export const ListModelVersionsRequestSchema: GenMessage<ListModelVersionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 15);

/**
 * @generated from message chalk.server.v1.ListModelVersionsResponse
 */
export type ListModelVersionsResponse = Message<"chalk.server.v1.ListModelVersionsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ModelVersion model_versions = 1;
   */
  modelVersions: ModelVersion[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListModelVersionsResponse.
 * Use `create(ListModelVersionsResponseSchema)` to create a new message.
 */
export const ListModelVersionsResponseSchema: GenMessage<ListModelVersionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 16);

/**
 * @generated from message chalk.server.v1.GetModelVersionRequest
 */
export type GetModelVersionRequest = Message<"chalk.server.v1.GetModelVersionRequest"> & {
  /**
   * @generated from field: string model_name = 1;
   */
  modelName: string;

  /**
   * @generated from field: uint64 version = 2;
   */
  version: bigint;

  /**
   * @generated from field: optional bool include_deleted = 3;
   */
  includeDeleted?: boolean;
};

/**
 * Describes the message chalk.server.v1.GetModelVersionRequest.
 * Use `create(GetModelVersionRequestSchema)` to create a new message.
 */
export const GetModelVersionRequestSchema: GenMessage<GetModelVersionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 17);

/**
 * @generated from message chalk.server.v1.GetModelVersionResponse
 */
export type GetModelVersionResponse = Message<"chalk.server.v1.GetModelVersionResponse"> & {
  /**
   * @generated from field: optional chalk.server.v1.ModelVersion model_version = 1;
   */
  modelVersion?: ModelVersion;
};

/**
 * Describes the message chalk.server.v1.GetModelVersionResponse.
 * Use `create(GetModelVersionResponseSchema)` to create a new message.
 */
export const GetModelVersionResponseSchema: GenMessage<GetModelVersionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 18);

/**
 * @generated from message chalk.server.v1.CreateModelArtifactRequest
 */
export type CreateModelArtifactRequest = Message<"chalk.server.v1.CreateModelArtifactRequest"> & {
  /**
   * @generated from field: string model_artifact_id = 5;
   */
  modelArtifactId: string;

  /**
   * @generated from field: chalk.models.v1.ModelArtifactSpec model_artifact = 2;
   */
  modelArtifact?: ModelArtifactSpec;

  /**
   * @generated from field: map<string, google.protobuf.Value> metadata = 4;
   */
  metadata: { [key: string]: Value };
};

/**
 * Describes the message chalk.server.v1.CreateModelArtifactRequest.
 * Use `create(CreateModelArtifactRequestSchema)` to create a new message.
 */
export const CreateModelArtifactRequestSchema: GenMessage<CreateModelArtifactRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 19);

/**
 * @generated from message chalk.server.v1.CreateModelArtifactResponse
 */
export type CreateModelArtifactResponse = Message<"chalk.server.v1.CreateModelArtifactResponse"> & {
  /**
   * @generated from field: chalk.server.v1.ModelArtifact model_artifact = 1;
   */
  modelArtifact?: ModelArtifact;
};

/**
 * Describes the message chalk.server.v1.CreateModelArtifactResponse.
 * Use `create(CreateModelArtifactResponseSchema)` to create a new message.
 */
export const CreateModelArtifactResponseSchema: GenMessage<CreateModelArtifactResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 20);

/**
 * @generated from message chalk.server.v1.CreateModelVersionRequest
 */
export type CreateModelVersionRequest = Message<"chalk.server.v1.CreateModelVersionRequest"> & {
  /**
   * @generated from field: string model_name = 1;
   */
  modelName: string;

  /**
   * @generated from field: string model_artifact_id = 5;
   */
  modelArtifactId: string;

  /**
   * @generated from field: chalk.models.v1.ModelArtifactSpec model_artifact = 2;
   */
  modelArtifact?: ModelArtifactSpec;

  /**
   * @generated from field: repeated string aliases = 3;
   */
  aliases: string[];

  /**
   * @generated from field: map<string, google.protobuf.Value> metadata = 4;
   */
  metadata: { [key: string]: Value };
};

/**
 * Describes the message chalk.server.v1.CreateModelVersionRequest.
 * Use `create(CreateModelVersionRequestSchema)` to create a new message.
 */
export const CreateModelVersionRequestSchema: GenMessage<CreateModelVersionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 21);

/**
 * @generated from message chalk.server.v1.CreateModelVersionResponse
 */
export type CreateModelVersionResponse = Message<"chalk.server.v1.CreateModelVersionResponse"> & {
  /**
   * @generated from field: chalk.server.v1.ModelVersion model_version = 1;
   */
  modelVersion?: ModelVersion;
};

/**
 * Describes the message chalk.server.v1.CreateModelVersionResponse.
 * Use `create(CreateModelVersionResponseSchema)` to create a new message.
 */
export const CreateModelVersionResponseSchema: GenMessage<CreateModelVersionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 22);

/**
 * @generated from message chalk.server.v1.ModelVersionKey
 */
export type ModelVersionKey = Message<"chalk.server.v1.ModelVersionKey"> & {
  /**
   * @generated from field: string model_name = 1;
   */
  modelName: string;

  /**
   * @generated from field: uint64 version = 2;
   */
  version: bigint;
};

/**
 * Describes the message chalk.server.v1.ModelVersionKey.
 * Use `create(ModelVersionKeySchema)` to create a new message.
 */
export const ModelVersionKeySchema: GenMessage<ModelVersionKey> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 23);

/**
 * @generated from message chalk.server.v1.UpdateModelVersionOperation
 */
export type UpdateModelVersionOperation = Message<"chalk.server.v1.UpdateModelVersionOperation"> & {
  /**
   * @generated from field: repeated string aliases = 1;
   */
  aliases: string[];

  /**
   * @generated from field: map<string, google.protobuf.Value> metadata = 2;
   */
  metadata: { [key: string]: Value };
};

/**
 * Describes the message chalk.server.v1.UpdateModelVersionOperation.
 * Use `create(UpdateModelVersionOperationSchema)` to create a new message.
 */
export const UpdateModelVersionOperationSchema: GenMessage<UpdateModelVersionOperation> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 24);

/**
 * @generated from message chalk.server.v1.UpdateModelVersionRequest
 */
export type UpdateModelVersionRequest = Message<"chalk.server.v1.UpdateModelVersionRequest"> & {
  /**
   * @generated from field: chalk.server.v1.ModelVersionKey model_version_key = 1;
   */
  modelVersionKey?: ModelVersionKey;

  /**
   * @generated from field: chalk.server.v1.UpdateModelVersionOperation update = 2;
   */
  update?: UpdateModelVersionOperation;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.UpdateModelVersionRequest.
 * Use `create(UpdateModelVersionRequestSchema)` to create a new message.
 */
export const UpdateModelVersionRequestSchema: GenMessage<UpdateModelVersionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 25);

/**
 * @generated from message chalk.server.v1.UpdateModelVersionResponse
 */
export type UpdateModelVersionResponse = Message<"chalk.server.v1.UpdateModelVersionResponse"> & {
  /**
   * @generated from field: chalk.server.v1.ModelVersion model_version = 1;
   */
  modelVersion?: ModelVersion;
};

/**
 * Describes the message chalk.server.v1.UpdateModelVersionResponse.
 * Use `create(UpdateModelVersionResponseSchema)` to create a new message.
 */
export const UpdateModelVersionResponseSchema: GenMessage<UpdateModelVersionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 26);

/**
 * @generated from message chalk.server.v1.DeleteModelVersionRequest
 */
export type DeleteModelVersionRequest = Message<"chalk.server.v1.DeleteModelVersionRequest"> & {
  /**
   * @generated from field: chalk.server.v1.ModelVersionKey model_version_key = 1;
   */
  modelVersionKey?: ModelVersionKey;
};

/**
 * Describes the message chalk.server.v1.DeleteModelVersionRequest.
 * Use `create(DeleteModelVersionRequestSchema)` to create a new message.
 */
export const DeleteModelVersionRequestSchema: GenMessage<DeleteModelVersionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 27);

/**
 * @generated from message chalk.server.v1.DeleteModelVersionResponse
 */
export type DeleteModelVersionResponse = Message<"chalk.server.v1.DeleteModelVersionResponse"> & {
  /**
   * @generated from field: chalk.server.v1.ModelVersion model_version = 1;
   */
  modelVersion?: ModelVersion;
};

/**
 * Describes the message chalk.server.v1.DeleteModelVersionResponse.
 * Use `create(DeleteModelVersionResponseSchema)` to create a new message.
 */
export const DeleteModelVersionResponseSchema: GenMessage<DeleteModelVersionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 28);

/**
 * @generated from message chalk.server.v1.GetModelArtifactUploadUrlsRequest
 */
export type GetModelArtifactUploadUrlsRequest = Message<"chalk.server.v1.GetModelArtifactUploadUrlsRequest"> & {
  /**
   * @generated from field: repeated string file_names = 1;
   */
  fileNames: string[];
};

/**
 * Describes the message chalk.server.v1.GetModelArtifactUploadUrlsRequest.
 * Use `create(GetModelArtifactUploadUrlsRequestSchema)` to create a new message.
 */
export const GetModelArtifactUploadUrlsRequestSchema: GenMessage<GetModelArtifactUploadUrlsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 29);

/**
 * @generated from message chalk.server.v1.GetModelArtifactUploadUrlsResponse
 */
export type GetModelArtifactUploadUrlsResponse = Message<"chalk.server.v1.GetModelArtifactUploadUrlsResponse"> & {
  /**
   * @generated from field: map<string, string> upload_urls = 1;
   */
  uploadUrls: { [key: string]: string };

  /**
   * @generated from field: string model_artifact_id = 2;
   */
  modelArtifactId: string;
};

/**
 * Describes the message chalk.server.v1.GetModelArtifactUploadUrlsResponse.
 * Use `create(GetModelArtifactUploadUrlsResponseSchema)` to create a new message.
 */
export const GetModelArtifactUploadUrlsResponseSchema: GenMessage<GetModelArtifactUploadUrlsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 30);

/**
 * @generated from message chalk.server.v1.DownloadModelArtifactRequest
 */
export type DownloadModelArtifactRequest = Message<"chalk.server.v1.DownloadModelArtifactRequest"> & {
  /**
   * @generated from field: chalk.server.v1.ModelVersionKey model_version_key = 1;
   */
  modelVersionKey?: ModelVersionKey;

  /**
   * @generated from field: optional string model_artifact_id = 2;
   */
  modelArtifactId?: string;
};

/**
 * Describes the message chalk.server.v1.DownloadModelArtifactRequest.
 * Use `create(DownloadModelArtifactRequestSchema)` to create a new message.
 */
export const DownloadModelArtifactRequestSchema: GenMessage<DownloadModelArtifactRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 31);

/**
 * @generated from message chalk.server.v1.DownloadModelArtifactResponse
 */
export type DownloadModelArtifactResponse = Message<"chalk.server.v1.DownloadModelArtifactResponse"> & {
  /**
   * @generated from field: string uri = 1 [deprecated = true];
   * @deprecated
   */
  uri: string;

  /**
   * @generated from field: chalk.server.v1.ModelArtifact model_artifact = 2;
   */
  modelArtifact?: ModelArtifact;

  /**
   * @generated from field: repeated string model_urls = 3;
   */
  modelUrls: string[];

  /**
   * @generated from field: repeated string additional_file_urls = 4;
   */
  additionalFileUrls: string[];
};

/**
 * Describes the message chalk.server.v1.DownloadModelArtifactResponse.
 * Use `create(DownloadModelArtifactResponseSchema)` to create a new message.
 */
export const DownloadModelArtifactResponseSchema: GenMessage<DownloadModelArtifactResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 32);

/**
 * @generated from message chalk.server.v1.GetModelReferencesRequest
 */
export type GetModelReferencesRequest = Message<"chalk.server.v1.GetModelReferencesRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * @generated from field: optional string model_name = 2;
   */
  modelName?: string;

  /**
   * @generated from field: optional uint32 model_version = 3;
   */
  modelVersion?: number;

  /**
   * @generated from field: optional string cursor = 4;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 5;
   */
  limit?: number;
};

/**
 * Describes the message chalk.server.v1.GetModelReferencesRequest.
 * Use `create(GetModelReferencesRequestSchema)` to create a new message.
 */
export const GetModelReferencesRequestSchema: GenMessage<GetModelReferencesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 33);

/**
 * @generated from message chalk.server.v1.ModelRelation
 */
export type ModelRelation = Message<"chalk.server.v1.ModelRelation"> & {
  /**
   * @generated from field: repeated string input_features = 1;
   */
  inputFeatures: string[];

  /**
   * @generated from field: string output_feature = 2;
   */
  outputFeature: string;
};

/**
 * Describes the message chalk.server.v1.ModelRelation.
 * Use `create(ModelRelationSchema)` to create a new message.
 */
export const ModelRelationSchema: GenMessage<ModelRelation> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 34);

/**
 * @generated from message chalk.server.v1.ModelReference
 */
export type ModelReference = Message<"chalk.server.v1.ModelReference"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string model_name = 2;
   */
  modelName: string;

  /**
   * @generated from field: uint64 version = 3;
   */
  version: bigint;

  /**
   * @generated from field: string deployment_id = 4;
   */
  deploymentId: string;

  /**
   * @generated from field: repeated chalk.server.v1.ModelRelation relations = 5;
   */
  relations: ModelRelation[];

  /**
   * @generated from field: repeated string resolvers = 6;
   */
  resolvers: string[];

  /**
   * @generated from field: optional chalk.graph.v1.SourceFileReference source_file_reference = 7;
   */
  sourceFileReference?: SourceFileReference;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.ModelReference.
 * Use `create(ModelReferenceSchema)` to create a new message.
 */
export const ModelReferenceSchema: GenMessage<ModelReference> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 35);

/**
 * @generated from message chalk.server.v1.GetModelReferencesResponse
 */
export type GetModelReferencesResponse = Message<"chalk.server.v1.GetModelReferencesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ModelReference model_references = 1;
   */
  modelReferences: ModelReference[];

  /**
   * @generated from field: optional string next_cursor = 4;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.GetModelReferencesResponse.
 * Use `create(GetModelReferencesResponseSchema)` to create a new message.
 */
export const GetModelReferencesResponseSchema: GenMessage<GetModelReferencesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 36);

/**
 * @generated from message chalk.server.v1.GetModelReferenceRequest
 */
export type GetModelReferenceRequest = Message<"chalk.server.v1.GetModelReferenceRequest"> & {
  /**
   * @generated from field: string model_id = 1 [deprecated = true];
   * @deprecated
   */
  modelId: string;

  /**
   * @generated from field: string model_name = 4;
   */
  modelName: string;

  /**
   * @generated from field: uint64 model_version = 2;
   */
  modelVersion: bigint;

  /**
   * @generated from field: string deployment_id = 3;
   */
  deploymentId: string;
};

/**
 * Describes the message chalk.server.v1.GetModelReferenceRequest.
 * Use `create(GetModelReferenceRequestSchema)` to create a new message.
 */
export const GetModelReferenceRequestSchema: GenMessage<GetModelReferenceRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 37);

/**
 * @generated from message chalk.server.v1.GetModelReferenceResponse
 */
export type GetModelReferenceResponse = Message<"chalk.server.v1.GetModelReferenceResponse"> & {
  /**
   * @generated from field: optional chalk.server.v1.ModelReference model_reference = 1;
   */
  modelReference?: ModelReference;
};

/**
 * Describes the message chalk.server.v1.GetModelReferenceResponse.
 * Use `create(GetModelReferenceResponseSchema)` to create a new message.
 */
export const GetModelReferenceResponseSchema: GenMessage<GetModelReferenceResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 38);

/**
 * @generated from message chalk.server.v1.RunCriterion
 */
export type RunCriterion = Message<"chalk.server.v1.RunCriterion"> & {
  /**
   * @generated from oneof chalk.server.v1.RunCriterion.run_identifier
   */
  runIdentifier: {
    /**
     * @generated from field: string run_id = 1;
     */
    value: string;
    case: "runId";
  } | {
    /**
     * @generated from field: string run_name = 4;
     */
    value: string;
    case: "runName";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string metric = 2;
   */
  metric?: string;

  /**
   * @generated from field: optional chalk.server.v1.RunCriterionDirection direction = 3;
   */
  direction?: RunCriterionDirection;
};

/**
 * Describes the message chalk.server.v1.RunCriterion.
 * Use `create(RunCriterionSchema)` to create a new message.
 */
export const RunCriterionSchema: GenMessage<RunCriterion> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 39);

/**
 * @generated from message chalk.server.v1.CreateModelVersionFromArtifactOverride
 */
export type CreateModelVersionFromArtifactOverride = Message<"chalk.server.v1.CreateModelVersionFromArtifactOverride"> & {
  /**
   * @generated from field: chalk.models.v1.ModelArtifactSpec spec = 1;
   */
  spec?: ModelArtifactSpec;

  /**
   * @generated from field: google.protobuf.FieldMask override_fields = 2;
   */
  overrideFields?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.CreateModelVersionFromArtifactOverride.
 * Use `create(CreateModelVersionFromArtifactOverrideSchema)` to create a new message.
 */
export const CreateModelVersionFromArtifactOverrideSchema: GenMessage<CreateModelVersionFromArtifactOverride> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 40);

/**
 * @generated from message chalk.server.v1.CreateModelVersionFromArtifactRequest
 */
export type CreateModelVersionFromArtifactRequest = Message<"chalk.server.v1.CreateModelVersionFromArtifactRequest"> & {
  /**
   * @generated from field: string model_name = 1;
   */
  modelName: string;

  /**
   * @generated from oneof chalk.server.v1.CreateModelVersionFromArtifactRequest.artifact_identifier
   */
  artifactIdentifier: {
    /**
     * @generated from field: string model_artifact_id = 2;
     */
    value: string;
    case: "modelArtifactId";
  } | {
    /**
     * @generated from field: chalk.server.v1.RunCriterion training_run = 3;
     */
    value: RunCriterion;
    case: "trainingRun";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated string aliases = 4;
   */
  aliases: string[];

  /**
   * @generated from field: optional chalk.server.v1.CreateModelVersionFromArtifactOverride override = 5;
   */
  override?: CreateModelVersionFromArtifactOverride;
};

/**
 * Describes the message chalk.server.v1.CreateModelVersionFromArtifactRequest.
 * Use `create(CreateModelVersionFromArtifactRequestSchema)` to create a new message.
 */
export const CreateModelVersionFromArtifactRequestSchema: GenMessage<CreateModelVersionFromArtifactRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 41);

/**
 * @generated from message chalk.server.v1.CreateModelVersionFromArtifactResponse
 */
export type CreateModelVersionFromArtifactResponse = Message<"chalk.server.v1.CreateModelVersionFromArtifactResponse"> & {
  /**
   * @generated from field: chalk.server.v1.ModelVersion model_version = 1;
   */
  modelVersion?: ModelVersion;
};

/**
 * Describes the message chalk.server.v1.CreateModelVersionFromArtifactResponse.
 * Use `create(CreateModelVersionFromArtifactResponseSchema)` to create a new message.
 */
export const CreateModelVersionFromArtifactResponseSchema: GenMessage<CreateModelVersionFromArtifactResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 42);

/**
 * @generated from message chalk.server.v1.ListModelArtifactsRequest
 */
export type ListModelArtifactsRequest = Message<"chalk.server.v1.ListModelArtifactsRequest"> & {
  /**
   * @generated from oneof chalk.server.v1.ListModelArtifactsRequest.filter
   */
  filter: {
    /**
     * @generated from field: string script_task_id = 1;
     */
    value: string;
    case: "scriptTaskId";
  } | {
    /**
     * @generated from field: string training_run_id = 4;
     */
    value: string;
    case: "trainingRunId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: chalk.server.v1.ListModelArtifactsFilters filters = 5;
   */
  filters?: ListModelArtifactsFilters;
};

/**
 * Describes the message chalk.server.v1.ListModelArtifactsRequest.
 * Use `create(ListModelArtifactsRequestSchema)` to create a new message.
 */
export const ListModelArtifactsRequestSchema: GenMessage<ListModelArtifactsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 43);

/**
 * @generated from message chalk.server.v1.ListModelArtifactsFilters
 */
export type ListModelArtifactsFilters = Message<"chalk.server.v1.ListModelArtifactsFilters"> & {
  /**
   * @generated from field: repeated string created_by = 1;
   */
  createdBy: string[];
};

/**
 * Describes the message chalk.server.v1.ListModelArtifactsFilters.
 * Use `create(ListModelArtifactsFiltersSchema)` to create a new message.
 */
export const ListModelArtifactsFiltersSchema: GenMessage<ListModelArtifactsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 44);

/**
 * @generated from message chalk.server.v1.ListModelArtifactsResponse
 */
export type ListModelArtifactsResponse = Message<"chalk.server.v1.ListModelArtifactsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ModelArtifact model_artifacts = 1;
   */
  modelArtifacts: ModelArtifact[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListModelArtifactsResponse.
 * Use `create(ListModelArtifactsResponseSchema)` to create a new message.
 */
export const ListModelArtifactsResponseSchema: GenMessage<ListModelArtifactsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 45);

/**
 * @generated from message chalk.server.v1.GetModelArtifactRequest
 */
export type GetModelArtifactRequest = Message<"chalk.server.v1.GetModelArtifactRequest"> & {
  /**
   * @generated from field: string model_artifact_id = 1;
   */
  modelArtifactId: string;
};

/**
 * Describes the message chalk.server.v1.GetModelArtifactRequest.
 * Use `create(GetModelArtifactRequestSchema)` to create a new message.
 */
export const GetModelArtifactRequestSchema: GenMessage<GetModelArtifactRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 46);

/**
 * @generated from message chalk.server.v1.GetModelArtifactResponse
 */
export type GetModelArtifactResponse = Message<"chalk.server.v1.GetModelArtifactResponse"> & {
  /**
   * @generated from field: optional chalk.server.v1.ModelArtifact model_artifact = 1;
   */
  modelArtifact?: ModelArtifact;
};

/**
 * Describes the message chalk.server.v1.GetModelArtifactResponse.
 * Use `create(GetModelArtifactResponseSchema)` to create a new message.
 */
export const GetModelArtifactResponseSchema: GenMessage<GetModelArtifactResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 47);

/**
 * @generated from message chalk.server.v1.ListModelsFilters
 */
export type ListModelsFilters = Message<"chalk.server.v1.ListModelsFilters"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ListModelsStatus statuses = 1;
   */
  statuses: ListModelsStatus[];

  /**
   * @generated from field: repeated string created_by = 2;
   */
  createdBy: string[];
};

/**
 * Describes the message chalk.server.v1.ListModelsFilters.
 * Use `create(ListModelsFiltersSchema)` to create a new message.
 */
export const ListModelsFiltersSchema: GenMessage<ListModelsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_model_registry, 48);

/**
 * @generated from enum chalk.server.v1.RunCriterionDirection
 */
export enum RunCriterionDirection {
  /**
   * @generated from enum value: RUN_CRITERION_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RUN_CRITERION_DIRECTION_MAX = 1;
   */
  MAX = 1,

  /**
   * @generated from enum value: RUN_CRITERION_DIRECTION_MIN = 2;
   */
  MIN = 2,
}

/**
 * Describes the enum chalk.server.v1.RunCriterionDirection.
 */
export const RunCriterionDirectionSchema: GenEnum<RunCriterionDirection> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_model_registry, 0);

/**
 * @generated from enum chalk.server.v1.ListModelsSortColumn
 */
export enum ListModelsSortColumn {
  /**
   * @generated from enum value: LIST_MODELS_SORT_COLUMN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LIST_MODELS_SORT_COLUMN_NAME = 1;
   */
  NAME = 1,

  /**
   * @generated from enum value: LIST_MODELS_SORT_COLUMN_CREATED_AT = 2;
   */
  CREATED_AT = 2,

  /**
   * @generated from enum value: LIST_MODELS_SORT_COLUMN_UPDATED_AT = 3;
   */
  UPDATED_AT = 3,
}

/**
 * Describes the enum chalk.server.v1.ListModelsSortColumn.
 */
export const ListModelsSortColumnSchema: GenEnum<ListModelsSortColumn> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_model_registry, 1);

/**
 * @generated from enum chalk.server.v1.ListModelsSortOrder
 */
export enum ListModelsSortOrder {
  /**
   * @generated from enum value: LIST_MODELS_SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LIST_MODELS_SORT_ORDER_ASCENDING = 1;
   */
  ASCENDING = 1,

  /**
   * @generated from enum value: LIST_MODELS_SORT_ORDER_DESCENDING = 2;
   */
  DESCENDING = 2,
}

/**
 * Describes the enum chalk.server.v1.ListModelsSortOrder.
 */
export const ListModelsSortOrderSchema: GenEnum<ListModelsSortOrder> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_model_registry, 2);

/**
 * @generated from enum chalk.server.v1.ListModelsStatus
 */
export enum ListModelsStatus {
  /**
   * @generated from enum value: LIST_MODELS_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LIST_MODELS_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: LIST_MODELS_STATUS_DELETED = 2;
   */
  DELETED = 2,
}

/**
 * Describes the enum chalk.server.v1.ListModelsStatus.
 */
export const ListModelsStatusSchema: GenEnum<ListModelsStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_model_registry, 3);

/**
 * @generated from service chalk.server.v1.ModelRegistryService
 */
export const ModelRegistryService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.ListModels
   */
  listModels: {
    methodKind: "unary";
    input: typeof ListModelsRequestSchema;
    output: typeof ListModelsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.GetModel
   */
  getModel: {
    methodKind: "unary";
    input: typeof GetModelRequestSchema;
    output: typeof GetModelResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.CreateModel
   */
  createModel: {
    methodKind: "unary";
    input: typeof CreateModelRequestSchema;
    output: typeof CreateModelResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.UpdateModel
   */
  updateModel: {
    methodKind: "unary";
    input: typeof UpdateModelRequestSchema;
    output: typeof UpdateModelResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.DeleteModel
   */
  deleteModel: {
    methodKind: "unary";
    input: typeof DeleteModelRequestSchema;
    output: typeof DeleteModelResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.ListModelVersions
   */
  listModelVersions: {
    methodKind: "unary";
    input: typeof ListModelVersionsRequestSchema;
    output: typeof ListModelVersionsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.GetModelVersion
   */
  getModelVersion: {
    methodKind: "unary";
    input: typeof GetModelVersionRequestSchema;
    output: typeof GetModelVersionResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.CreateModelVersion
   */
  createModelVersion: {
    methodKind: "unary";
    input: typeof CreateModelVersionRequestSchema;
    output: typeof CreateModelVersionResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.CreateModelArtifact
   */
  createModelArtifact: {
    methodKind: "unary";
    input: typeof CreateModelArtifactRequestSchema;
    output: typeof CreateModelArtifactResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.CreateModelVersionFromArtifact
   */
  createModelVersionFromArtifact: {
    methodKind: "unary";
    input: typeof CreateModelVersionFromArtifactRequestSchema;
    output: typeof CreateModelVersionFromArtifactResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.UpdateModelVersion
   */
  updateModelVersion: {
    methodKind: "unary";
    input: typeof UpdateModelVersionRequestSchema;
    output: typeof UpdateModelVersionResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.DeleteModelVersion
   */
  deleteModelVersion: {
    methodKind: "unary";
    input: typeof DeleteModelVersionRequestSchema;
    output: typeof DeleteModelVersionResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.DownloadModelArtifact
   */
  downloadModelArtifact: {
    methodKind: "unary";
    input: typeof DownloadModelArtifactRequestSchema;
    output: typeof DownloadModelArtifactResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.GetModelReferences
   */
  getModelReferences: {
    methodKind: "unary";
    input: typeof GetModelReferencesRequestSchema;
    output: typeof GetModelReferencesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.GetModelReference
   */
  getModelReference: {
    methodKind: "unary";
    input: typeof GetModelReferenceRequestSchema;
    output: typeof GetModelReferenceResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.GetModelArtifactUploadUrls
   */
  getModelArtifactUploadUrls: {
    methodKind: "unary";
    input: typeof GetModelArtifactUploadUrlsRequestSchema;
    output: typeof GetModelArtifactUploadUrlsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.ListModelArtifacts
   */
  listModelArtifacts: {
    methodKind: "unary";
    input: typeof ListModelArtifactsRequestSchema;
    output: typeof ListModelArtifactsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ModelRegistryService.GetModelArtifact
   */
  getModelArtifact: {
    methodKind: "unary";
    input: typeof GetModelArtifactRequestSchema;
    output: typeof GetModelArtifactResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_model_registry, 0);

